import BubbleHero, { BubbleContentWrapper } from './BubbleHero'

export { BubbleContentWrapper }

export default BubbleHero
